module.exports = "https://assets.niwcorp.com/_next/static/images/trizenLogo-b2825e76738a21d5919a2e7490d4aafc.jpg";